import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useSiteSettings } from '../context/SiteSettingsContext';

/**
 * Injects search-engine verification meta tags into <head> based on
 * site-settings managed by the master/admin (so users can change tokens
 * without redeploying).
 *
 * Mounted ONCE in App.js — uses react-helmet-async to update the head.
 */
export const SearchConsoleVerification = () => {
  const { settings } = useSiteSettings() || {};
  const seo = settings?.seo || {};

  const googleToken = seo.google_site_verification;
  const bingToken = seo.bing_site_verification;

  if (!googleToken && !bingToken) return null;

  return (
    <Helmet>
      {googleToken && (
        <meta name="google-site-verification" content={googleToken} />
      )}
      {bingToken && (
        <meta name="msvalidate.01" content={bingToken} />
      )}
    </Helmet>
  );
};

export default SearchConsoleVerification;
